// extracted by mini-css-extract-plugin
export default {"rightContainer":"PcV4ISGNkQ5HyM93UeVC","title":"xQ6vIllhsYto9VgvdrNm"};